export default "/images/sa.svg?c7c0a1d9dea4eb287a5bacf3f3678091";